<script setup lang="ts">
/**
 * Closing call to action, ported from the template: light surface, centred
 * block, one primary action and a reassurance line, with the decorative
 * element bleeding off the right edge on wide screens.
 */
const { t } = useI18n()
const { isAuthenticated } = useAuthUser()
const { jobPackPrice } = usePremiumPlans()
</script>

<template>
  <section class="sofax surface-alt overflow-hidden">
    <div class="section-space">
      <div class="shell relative z-10">
        <div class="mx-auto max-w-3xl text-center">
          <h2>{{ t('homepage.finalCta.title') }}</h2>
          <p class="mt-5 text-lg">{{ t('homepage.finalCta.subtitle') }}</p>
        </div>

        <div class="mx-auto mt-[3.125rem] max-w-sm text-center">
          <SofaxBtn
            :to="isAuthenticated ? '/cv' : '/free-cv-builder'"
            :label="t('homepage.hero.cta')"
            variant="accent"
          />
          <span class="mt-4 block text-base text-muted dark:text-gray-400">
            {{ t('homepage.hero.reassurance', { price: jobPackPrice }) }}
          </span>
        </div>

        <img
          src="/sofax/cta-1-element-1.svg"
          alt=""
          aria-hidden="true"
          width="414"
          height="367"
          class="pointer-events-none absolute -bottom-24 right-0 -z-10 hidden opacity-70 xl:inline-block"
        >
      </div>
    </div>
  </section>
</template>
